module.exports = __webpack_public_path__ + "media/images/avatar/development/parents/14-c1a697d8df97d4acc949afcd77aa2361.jpg";